import BaseModel from './BaseModel';

class PolicyholderTemplateModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.name = data.name || '';
    this.category = data.category ? {
      id: data.category.id || 0,
      name: data.category.name || '',
    } : null;
    this.lastCompleted = data.last_completed ? this.stringToDate(data.last_completed) : null;
    this.completedTotal = data.completed_total || 0;
  }
}

export default PolicyholderTemplateModel;
